
export default function generateTextForSupportedLanguages(text) {
    let lngObj = {};
    for (const lng of window.auth.project.SupportedLanguages) {
        lngObj[lng] = text;
    }
    return lngObj;
}